(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("ReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define("input-format", ["React", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["input-format"] = factory(require("React"), require("ReactDOM"));
	else
		root["input-format"] = factory(root["React"], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_108__, __WEBPACK_EXTERNAL_MODULE_109__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition